import 'consumerweb-shim';
import React from 'react';
import { connect } from 'react-redux';

import SearchBox from '../../searchBox';

export class SearchBoxContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    var nameValues = this.parseFPTIInfo(props && props.fptiInfo);

    var initialState = {
      fptiInfo: {
        pgrp: nameValues.pgrp,
        page: nameValues.page,
      },
    };
    this.state = initialState;
  }

  parseFPTIInfo = (fptiData) => {
    var nameValues = [];
    var pairs = decodeURIComponent(fptiData).split('&');
    var i;
    for (i = 0; i < pairs.length; i++) {
      var parts = pairs[i].split('=');
      nameValues[parts[0]] = parts[1];
    }
    return nameValues;
  };

  render() {
    let searchSubmitUrl = this.props.coBrand + 'search';

    return (
      <div>
        <SearchBox
          {...this.props}
          fptiInfo={this.state.fptiInfo}
          searchSubmitUrl={searchSubmitUrl}
        />
      </div>
    );
  }
}

export default connect(({ server }) => ({
  // connects reducer with component
  states: server.states,
  categories: server.categories,
  labels: server.labels,
  coBrand: server.coBrand,
  fptiInfo: server.fptiInfo,
}))(SearchBoxContainer);
